module.exports = __webpack_public_path__ + "assets/img/logo.28d00a1f.png";